// ========================================
// CONFIGURATION VAPID - Notifications Push
// ========================================

/**
 * INSTRUCTIONS POUR GÉNÉRER VOS CLÉS VAPID:
 * 
 * 1. Allez dans Firebase Console: https://console.firebase.google.com
 * 2. Sélectionnez votre projet
 * 3. Allez dans "Project Settings" (⚙️ Paramètres du projet)
 * 4. Cliquez sur l'onglet "Cloud Messaging"
 * 5. Sous "Web Push certificates", cliquez sur "Generate key pair"
 * 6. Copiez la clé publique générée
 * 7. Remplacez 'YOUR_VAPID_PUBLIC_KEY_HERE' ci-dessous par votre clé
 * 
 * ALTERNATIVE - Utiliser Firebase CLI:
 * ```bash
 * npm install -g firebase-tools
 * firebase login
 * firebase projects:list
 * firebase functions:config:get
 * ```
 * 
 * FORMAT DE LA CLÉ:
 * La clé VAPID est une chaîne Base64 de ~88 caractères
 * Exemple: "BKxM7pqN8..." (ne pas utiliser cet exemple!)
 */

// ⚠️ IMPORTANT: Ne commitez JAMAIS cette clé dans un repo public!
// Pour la production, utilisez des variables d'environnement:
// process.env.REACT_APP_VAPID_PUBLIC_KEY

export const VAPID_PUBLIC_KEY = 'YOUR_VAPID_PUBLIC_KEY_HERE';

// Pour tester si la clé est configurée
export const isVapidConfigured = () => {
  return VAPID_PUBLIC_KEY !== 'YOUR_VAPID_PUBLIC_KEY_HERE' && 
         VAPID_PUBLIC_KEY.length > 80;
};

// Message d'erreur si non configuré
export const VAPID_NOT_CONFIGURED_MESSAGE = `
⚠️ Les clés VAPID ne sont pas configurées.
Les notifications push ne fonctionneront pas tant que vous n'aurez pas:
1. Généré une paire de clés VAPID dans Firebase Console
2. Remplacé VAPID_PUBLIC_KEY dans ce fichier
`;

export default {
  VAPID_PUBLIC_KEY,
  isVapidConfigured,
  VAPID_NOT_CONFIGURED_MESSAGE
};
